import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { TicketPreview } from './TicketDesignModal'; // Reuse the preview from TicketDesignModal

export default function PrintPreviewModal({ open, onClose, design, ticket }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Print Ticket Preview</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <TicketPreview design={design} ticket={ticket} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button variant="contained" color="primary" onClick={() => window.print()}>Print</Button>
      </DialogActions>
    </Dialog>
  );
}
